import React from 'react'
import { ActiveInstallationContextProps } from '../types'

export const ActiveInstallationContext = React.createContext<ActiveInstallationContextProps | undefined>(undefined)

export const useActiveInstallationContext = (): ActiveInstallationContextProps | undefined => {
  return React.useContext(ActiveInstallationContext)
}
